export const translations = {
    en: {
        meta: {
            siteName: "Plomb Tech Reno Inc.",
            home: {
                title: "Plomb Tech Reno Inc. — Plumbing & Renovation in l'Islet",
                description:
                    "Plumbing, renovation and construction services in l'Islet.  Licensed & insured,  12+ years on the job.",
            },
            services: {
                title: "Services — Plumbing, Repair, Renovation & Emergency | Plomb Tech Reno Inc.",
                description:
                    "Installation, repair, renovation, drain & sewer, plumbing in l'Islet. Flat-rate quotes, code-compliant work.",
            },
            about: {
                title: "About Us — Trade-Trained, Family-Run | Plomb Tech Reno Inc.",
                description:
                    "Plomb Tech Reno Inc. is a l'Islet-based plumbing and construction company with  12+ years experience, workmanship warranty.",
            },
            contact: {
                title: "Contact & Free Quote | Plomb Tech Reno Inc.",
                description:
                    "Get a free, no-pressure plumbing quote as soon as possible. Call (581) 888-9419 or send your project brief. Serving l'Islet & surroundings.",
            },
        },
        nav: {
            home: "Home",
            services: "Services",
            about: "About",
            contact: "Contact",
            callNow: "Call / Text",
            languageLabel: "Language",
        },
        common: {
            phone: "+1 (581) 888-9419",
            phoneShort: "(581) 888-9419",
            email: "PlombTechReno@gmail.com",
            tagline: "Plumbing",
            footerNavigate: "Navigate",
            footerReach: "Reach Us",
            footerHours: "Mon–Fri · 8:00 — 17:00",
            footerEmergency: "Plumbing, renovation Service",
            footerNote: "© {year} Plomb Tech Réno Inc. · Licensed & Insured",
            footerSlogan: "Built tough. Built right.",
            footerDesc:
                "Plumbing and renovation services. Built for quality, precision, and the long haul.",
        },
        home: {
            heroOverline: "◣ Plumbing · Renovation · Construction",
            heroTitle1: "We Build.",
            heroTitle2: "We Fix.",
            heroTitle3: "We Flow.",
            heroDesc:
                "Plomb Tech Reno Inc. is a no-nonsense plumbing & construction company. Heavy-duty work, honest pricing, and jobs done right the first time.",
            heroQuoteBtn: "Get a Free Quote",
            heroServicesBtn: "See Services",
            heroBadgeNumber: " 12+",
            heroBadgeLabel: "Years on the job",
            trustItems: [
                "LICENSED & INSURED",
                "12+ YEARS EXPERIENCE",
                "FLAT-RATE QUOTES",
                "RESIDENTIAL & COMMERCIAL",
                "100% SATISFACTION",
            ],
            servicesOverline: "02 — What we do",
            servicesTitle1: "Tough jobs.",
            servicesTitle2: "Clean finishes.",
            allServices: "All Services",
            services: [
                {
                    title: "Plumbing",
                    desc: "Pipes, fixtures, water heaters — installed clean, code-compliant, and built to last.",
                },
                {
                    title: "Renovation",
                    desc: "Full bathroom and kitchen plumbing renos with zero-shortcut craftsmanship.",
                },
                {
                    title: "Repair",
                    desc: "Burst pipes. Flooded basements. We answer the phone.",
                },
            ],
            whyOverline: "03 — Why us",
            whyTitle1: "Built on grit.",
            whyTitle2: "Backed by guarantee.",
            why: [
                {
                    title: "Licensed & Insured",
                    desc: "Every job is fully covered. No grey zones, no surprises.",
                },
                {
                    title: "On-Time, Always",
                    desc: "If we say 9 AM, the truck is in your driveway at 8:55.",
                },
                {
                    title: "Workmanship Warranty",
                    desc: "We stand behind every weld, joint, and fixture we install.",
                },
            ],
            ctaOverline: "◣ Call to get an appointment",
            ctaTitle1: "Need it fixed",
            ctaTitle2: "Fast?",
            ctaCall: "Call (581) 888-9419",
            ctaQuote: "Request a Quote",
        },
        services: {
            headerOverline: "◣ Services",
            headerTitle1: "Every pipe.",
            headerTitle2: "Every problem.",
            headerTitle3: "Solved.",
            headerDesc:
                "From tiny drips to full reno rough-ins — Plomb Tech Reno Inc. handles every plumbing job with the same brutal commitment to quality.",
            cards: [
                {
                    title: "Installation",
                    desc: "Full plumbing systems, fixtures, taps, water heaters and connection lines installed to spec.",
                    items: ["Water heaters", "Faucets & sinks", "Toilets & showers", "Supply lines"],
                },
                {
                    title: "Repair",
                    desc: "Diagnose and fix leaks, drips, low pressure, clogs and broken fixtures fast.",
                    items: ["Leak detection", "Drain unclogging", "Tap repair", "Pressure issues"],
                },
                {
                    title: "Renovation",
                    desc: "Full bathroom and kitchen plumbing rebuilds — rough-in to finish trim.",
                    items: ["Bathroom renos", "Kitchen plumbing", "Re-piping", "Layout changes"],
                },
                {
                    title: "Service",
                    desc: "Rapid response for burst pipes, floods and major leaks.",
                    items: ["Burst pipes", "Flood response", "Sewer backup"],
                },
                {
                    title: "Drain & Sewer",
                    desc: "Camera inspection, hydro-jetting and full sewer line replacement.",
                    items: ["Camera inspect", "Hydro-jetting", "Line replacement"],
                },
                {
                    title: "New Construction",
                    desc: "Plumbing rough-in for new builds, additions and commercial projects.",
                    items: ["Residential builds", "Additions", "Commercial fit-out", "Permits handled"],
                },
            ],
            tagIndustrial: "Industrial · Pipework",
            tagRepair: "Repair · Heaters",
            processOverline: "04 — How we work",
            processTitle1: "Four steps.",
            processTitle2: "Zero fluff.",
            process: [
                ["01", "Call", "Tell us the problem. We listen and book the right slot."],
                ["02", "Inspect", "On-site diagnostic and a clear flat-rate quote — upfront."],
                ["03", "Execute", "Clean job site, code-compliant work, no shortcuts."],
                ["04", "Warranty", "We sign off, leave it spotless, and back the work."],
            ],
            ctaTitle: "Got a job in mind?",
            ctaBtn: "Get a free quote",
        },
        about: {
            headerOverline: "◣ Who we are",
            headerTitle1: "Trade-trained.",
            headerTitle2: "Owner-operated.",
            headerTitle3: "Built for the long haul.",
            storyOverline: "01 — Our story",
            storyTitle1: "Started on",
            storyTitle2: "a single wrench.",
            storyP1:
                "Plomb Tech Reno Inc. started in a one-truck garage with a simple promise: do honest plumbing work, charge fair prices, and never leave a job unfinished.",
            storyP2:
                " We are licensed, insured, and obsessive about clean job sites — because how you work is what you ship.",
            storyP3: "No filler. No upsell traps. Just pipes, fittings, and craftsmanship that holds.",
            stats: [
                [" 12+", "Years experience"],
                ["1K", "Jobs completed"],
                ["96%", "Repeat clients"],
            ],
            valuesOverline: "02 — Our values",
            valuesTitle: "What we stand on.",
            values: [
                {
                    title: "Precision",
                    desc: "Measure twice. Solder once. Every joint is tested before we leave.",
                },
                {
                    title: "Speed",
                    desc: "We respect your time — fast quotes, on-time arrivals, no dragging out invoices.",
                },
                {
                    title: "Honesty",
                    desc: "Flat-rate pricing. Nothing hidden. If you don't need it, we won't sell it.",
                },
            ],
            ctaOverline: "Work with us",
            ctaTitle: "Ready to let us do the work ?",
            ctaBtn: "Start a project",
        },
        contact: {
            headerOverline: "◣ Contact",
            headerTitle1: "Get a quote.",
            headerTitle2: "No pressure.",
            headerDesc:
                "Tell us a bit about your project. We'll review and get back as soon as possible with honest, flat-rate pricing.",
            formOverline: "01 — Project brief",
            formTitle: "Tell us the job.",
            contactTitle: "Talk to our team.",
            contactDescription: "Call, email, or browse our service area details below. We’ll respond within one business day.",
            labelName: "Name *",
            labelEmail: "Email *",
            labelPhone: "Phone",
            labelService: "Service",
            labelMessage: "Message *",
            placeholderName: "xxxx xxxxxxx",
            placeholderEmail: "xxxx@email.com",
            placeholderPhone: "(xxx) xxx-xxxx",
            placeholderMessage: "Briefly describe the issue or project...",
            serviceOptions: {
                placeholder: "Select a service",
                installation: "Installation",
                repair: "Repair",
                renovation: "Renovation",
                emergency: "Emergency",
                drain: "Drain & Sewer",
                construction: "New Construction",
            },
            requiredNote: "* Required · We respond as fast as possible.",
            submit: "Send Request",
            successBanner: "Error call or send and email, thank you.",
            errorToast: "Please fill in your name, email, and message.",
            successToast: "Error call or send and email, thank you.",
            sideOverline: "Direct line",
            sideCallLabel: "Call us",
            sideEmailLabel: "Email",
            sideAreaLabel: "Service area",
            sideAreaValue: " L'Islet & Surroundings",
            sideHoursLabel: "Hours",
            sideHoursValue: "Mon–Fri · 8:00 — 17:00",
            sideHoursNote: "Plumbing service",
            sideImageTag: "Always on call",
        },
    },
    fr: {
        meta: {
            siteName: "Plomb Tech Reno Inc.",
            home: {
                title: "Plomb Tech Reno Inc. — Plomberie & Rénovation à l'Islet",
                description:
                    "Plomberie, rénovation et construction robustes dans l'Islet. Licenciés et assurés, plus de 15 ans d'expérience.",
            },
            services: {
                title: "Services — Plomberie, Réparation, Rénovation | Plomb Tech Reno Inc.",
                description:
                    "Installation, réparation, rénovation, drains et égouts, nouvelle construction et à l'Islet. Tarifs forfaitaires, conformes au code.",
            },
            about: {
                title: "À propos — Métier maîtrisé, entreprise proprietaire opérateur | Plomb Tech Reno Inc. ",
                description:
                    "Plomb Tech Reno Inc. est une compagnie de plomberie et construction basée à L'Islet avec plus de 15 ans d'expérience et une garantie sur la main-d'œuvre.",
            },
            contact: {
                title: "Contact & Soumission gratuite | Plomb Tech Reno Inc.",
                description:
                    "Obtenez une soumission gratuite et sans pression le plus rapidement possible. Appelez le (581) 888-9419 ou envoyez votre projet. L'Islet et environs.",
            },
        },
        nav: {
            home: "Accueil",
            services: "Services",
            about: "À propos",
            contact: "Contact",
            callNow: "Appel / Texto",
            languageLabel: "Langue",
        },
        common: {
            phone: "+1 (581) 888-9419",
            phoneShort: "(581) 888-9419",
            email: "PlombTechReno@gmail.com",
            tagline: "Plomberie",
            footerNavigate: "Navigation",
            footerReach: "Joindre",
            footerHours: "Lun–Ven · 8 h — 17 h",
            footerNote: "© {year} Plomb Tech Réno Inc. · Licenciés & Assurés",
            footerSlogan: "Du solide. Du bien fait.",
            footerDesc:
                "Services de plomberie et de rénovation robustes. Conçus pour la qualité, la précision et la durée.",
        },
        home: {
            heroOverline: "◣ Plomberie · Rénovation · Construction",
            heroTitle1: "On bâtit.",
            heroTitle2: "On répare.",
            heroTitle3: "On est de service.",
            heroDesc:
                "Plomb Tech Reno Inc., c'est une compagnie de plomberie et de construction sans détour. Travail robuste, prix honnêtes, et chantiers réussis du premier coup.",
            heroQuoteBtn: "Soumission gratuite",
            heroServicesBtn: "Voir les services",
            heroBadgeNumber: "12+",
            heroBadgeLabel: "Années sur le terrain",
            trustItems: [
                "LICENCIÉS & ASSURÉS",
                "12+ ANS D'EXPÉRIENCE",
                "TARIFS FORFAITAIRES",
                "RÉSIDENTIEL & COMMERCIAL",
                "100% SATISFACTION",
            ],
            servicesOverline: "02 — Ce qu'on fait",
            servicesTitle1: "Du gros boulot.",
            servicesTitle2: "Des finitions nettes.",
            allServices: "Tous les services",
            services: [
                {
                    title: "Plomberie",
                    desc: "Tuyauterie, robinetterie, chauffe-eau — posés proprement, conformes au code, faits pour durer.",
                },
                {
                    title: "Rénovation",
                    desc: "Rénos complètes de salles de bain et cuisines, sans raccourcis sur la qualité.",
                },
                {
                    title: "Réparation",
                    desc: "Tuyaux qui éclatent, sous-sols inondés.",
                },
            ],
            whyOverline: "03 — Pourquoi nous",
            whyTitle1: "Bâtis sur le travail.",
            whyTitle2: "Garantis sur l'honneur.",
            why: [
                {
                    title: "Licenciés & assurés",
                    desc: "Chaque chantier est entièrement couvert. Aucune zone grise, aucune surprise.",
                },
                {
                    title: "À l'heure, toujours",
                    desc: "Si on dit 9 h, le camion est dans votre entrée à 8 h 55.",
                },
                {
                    title: "Garantie main-d'œuvre",
                    desc: "On répond de chaque soudure, joint et accessoire qu'on installe.",
                },
            ],
            ctaOverline: "◣ Ligne d'appel pour prendre rendez-vous",
            ctaTitle1: "Besoin de réparer",
            ctaTitle2: "Rapidement?",
            ctaCall: "Appeler le (581) 888-9419",
            ctaQuote: "Demander une soumission",
        },
        services: {
            headerOverline: "◣ Index 01 — Services",
            headerTitle1: "Chaque tuyau.",
            headerTitle2: "Chaque problème.",
            headerTitle3: "Réglé.",
            headerDesc:
                "De la petite fuite aux rénos complètes — Plomb Tech Reno Inc. traite chaque chantier avec la même exigence brute de qualité.",
            cards: [
                {
                    title: "Installation",
                    desc: "Systèmes de plomberie complets, robinetterie, chauffe-eau et lignes d'alimentation, posés selon les règles.",
                    items: ["Chauffe-eau", "Robinets & éviers", "Toilettes & douches", "Lignes d'alimentation"],
                },
                {
                    title: "Réparation",
                    desc: "Diagnostic et réparation rapide des fuites, gouttes, basse pression, blocages et accessoires brisés.",
                    items: ["Détection de fuites", "Débouchage de drains", "Réparation de robinets", "Problèmes de pression"],
                },
                {
                    title: "Rénovation",
                    desc: "Reconstructions complètes de plomberie de salle de bain et cuisine — du rough-in à la finition.",
                    items: ["Rénos salle de bain", "Plomberie de cuisine", "Re-tuyauterie", "Changements de plan"],
                },
                {
                    title: "Service",
                    desc: "Réponse rapide pour tuyaux éclatés, inondations et fuites majeures.",
                    items: ["Tuyaux éclatés", "Réponse inondation", "Refoulement d'égout"],
                },
                {
                    title: "Drains & Égouts",
                    desc: "Inspection caméra, hydro-jet et remplacement complet de conduite d'égout.",
                    items: ["Inspection caméra", "Hydro-jet", "Réparation", "Remplacement de conduite"],
                },
                {
                    title: "Nouvelle construction",
                    desc: "Plomberie de rough-in pour nouvelles constructions, agrandissements et projets commerciaux.",
                    items: ["Constructions résidentielles", "Agrandissements", "Aménagement commercial", "Permis gérés"],
                },
            ],
            tagIndustrial: "Industriel · Tuyauterie",
            tagRepair: "Réparation · Chauffe-eau",
            processOverline: "04 — Comment on travaille",
            processTitle1: "Quatre étapes.",
            processTitle2: "Zéro blabla.",
            process: [
                ["01", "Appel", "Décrivez le problème. On écoute et on fixe le bon créneau."],
                ["02", "Inspection", "Diagnostic sur place et soumission forfaitaire claire — d'avance."],
                ["03", "Exécution", "Chantier propre, travail conforme, aucun raccourci."],
                ["04", "Garantie", "On valide, on laisse impeccable, et on garantit le travail."],
            ],
            ctaTitle: "Un projet en tête?",
            ctaBtn: "Soumission gratuite",
        },
        about: {
            headerOverline: "◣ Qui nous sommes",
            headerTitle1: "Métier maîtrisé.",
            headerTitle2: "Entreprise opérateur propriétaire.",
            headerTitle3: "Faits pour durer.",
            storyOverline: "01 — Notre histoire",
            storyTitle1: "Commencé avec",
            storyTitle2: "une seule clé.",
            storyP1:
                "Plomb Tech Reno Inc. a démarré dans un garage à un seul camion, avec une promesse simple : faire de la plomberie honnête, à juste prix, et ne jamais laisser un chantier inachevé.",
            storyP2:
                " On est licenciés, assurés, et obsédés par les chantiers propres — parce que la manière de travailler, c'est ça qu'on livre.",
            storyP3:
                "Pas de superflu. Aucun piège de vente. Juste des tuyaux, des raccords et un savoir-faire qui tient.",
            stats: [
                ["12+", "Années d'expérience"],
                ["1K", "Chantiers réalisés"],
                ["96%", "Clients fidèles"],
            ],
            valuesOverline: "02 — Nos valeurs",
            valuesTitle: "Sur quoi on tient.",
            values: [
                {
                    title: "Précision",
                    desc: "Mesurer deux fois. Souder une fois. Chaque joint est testé avant qu'on parte.",
                },
                {
                    title: "Rapidité",
                    desc: "On respecte votre temps — soumissions rapides, arrivées à l'heure, factures sans traîner.",
                },
                {
                    title: "Honnêteté",
                    desc: "Tarifs forfaitaires. Rien de caché. Si vous n'en avez pas besoin, on ne le vend pas.",
                },
            ],
            ctaOverline: "Travailler avec nous",
            ctaTitle: "Prêt à travailler avec nous?",
            ctaBtn: "Démarrer un projet",
        },
        contact: {
            headerOverline: "◣ Contact",
            headerTitle1: "Une soumission.",
            headerTitle2: "Sans pression.",
            headerDesc:
                "Parlez-nous brièvement de votre projet. On revient vers vous en 48 heures avec un prix forfaitaire honnête.",
            formOverline: "01 — Brief de projet",
            formTitle: "Décrivez le chantier.",
            contactTitle: "Parlez à notre équipe.",
            contactDescription: "Appelez, envoyez un courriel ou consultez nos détails de zone de service ci-dessous. Nous répondons sous un jour ouvrable.",
            labelName: "Nom *",
            labelEmail: "Courriel *",
            labelPhone: "Téléphone",
            labelService: "Service",
            labelMessage: "Message *",
            placeholderName: "xxxx xxxxxxx",
            placeholderEmail: "xxxxx@courriel.com",
            placeholderPhone: "(xxx) xxx-xxxx",
            placeholderMessage: "Décrivez brièvement le problème ou le projet...",
            serviceOptions: {
                placeholder: "Choisir un service",
                installation: "Installation",
                repair: "Réparation",
                renovation: "Rénovation",
                emergency: "Urgence",
                drain: "Drains & égouts",
                construction: "Nouvelle construction",
            },
            requiredNote: "* Requis · On répond le plus rapidement possible.",
            submit: "Envoyer la demande",
            successBanner: "Erreur veuilez appeler ou envoyer un courriel, merci.",
            errorToast: "Veuillez remplir votre nom, courriel et message.",
            successToast: "Erreur veuilez appeler ou envoyer un courriel, merci.",
            sideOverline: "Ligne directe",
            sideCallLabel: "Appelez-nous",
            sideEmailLabel: "Courriel",
            sideAreaLabel: "Zone de service",
            sideAreaValue: "L'Islet & environs",
            sideHoursLabel: "Heures",
            sideHoursValue: "Lun–Ven · 8 h — 17 h",
            sideImageTag: "Toujours en service",
        },
    },
};

export const SUPPORTED_LANGS = ["en", "fr"];
export const DEFAULT_LANG = "fr";
